// 充值交易（充币）模块 - 简体中文
export default {
  tabs: {
    summary: "交易汇总",
    counterparty: "交易对手",
    details: "交易详情",
  },
  common: {
    totalPrefix: "共计",
    totalSuffix: "条数据",
    download: "下载",
    downloadFilename: "数据明细",
    loading: "拼命加载中",
    empty: "暂无数据",
    copySuccess: "复制成功",
  },
  summary: {
    columns: {
      title: "交易方向",
      totalCount: "交易次数",
      currency: "币种",
      totalQuantity: "交易总数量",
    },
  },
  rival: {
    columns: {
      title: "交易方向",
      counterparty: "交易对手",
      totalCount: "交易次数",
      currency: "币种",
      totalQuantity: "交易总数量",
    },
    directions: {
      ALL: "双向",
      INFLOW: "流入",
      OUTFLOW: "流出",
    },
  },
  details: {
    columns: {
      title: "交易方向",
      counterparty: "交易对手",
      currency: "币种",
      quantity: "交易数量",
      txTime: "交易时间",
      hash: "交易哈希",
    },
  },
};
